import requestor from "requestor";

import BaseRoute from "utils/base_route";

import issueOverrideTagsFetch from "modules/issue_override_tags/actions/fetch";
import clearIssueOverrideTags from "modules/issue_override_tags/actions/clear";

import IssueOverrideTags from "./containers/issue_override_tag";

export default class IssueOverrideTagsRoute extends BaseRoute {
  constructor(store) {
    super("issueoverridetags", store);
  }

  getComponents(location, cb) {
    cb(null, IssueOverrideTags);
  }

  onEnter(state) {
    this.fetchData(state);
  }

  fetchData(state) {
    this.fetchIssueOverrideTags(state);
  }

  fetchIssueOverrideTags(state) {
    const {organisationId} = state.params;
    const {dispatch} = this.store;
    dispatch(issueOverrideTagsFetch(requestor)(organisationId));
  }

  clearActiveData(state) {
    const {organisationId} = state.params;
    const {dispatch} = this.store;
    dispatch(clearIssueOverrideTags(organisationId));
  }
}
